import { createAction } from 'typesafe-actions';

import type { FieldsSpec, OperationsSpec, TemplateDto } from '@/services/ws-bi/src/main/resources/rest-api';
import type { IdConversationDto } from '@/services/ws-genai/src/main/resources/rest-api';

export const setAssistantConversationId = createAction('setAssistantConversationId')<IdConversationDto | null>();
export const setFieldSpecs = createAction('setFieldSpecs')<FieldsSpec>();
export const setOperationSpecs = createAction('setOperationSpecs')<OperationsSpec>();
export const setTemplate = createAction('setTemplate')<TemplateDto | null>();
export const setTemplates = createAction('setTemplates')<TemplateDto[]>();
export const removeTemplate = createAction('removeTemplate')<string>();
export const setSendModalOpened = createAction('setSendModalOpened')<boolean>();
